import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import OraclesImage from "./images/oracles1.png";
import HeroImage from "./images/stamps.png";

const OraclesDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={OraclesImage}
              alt="Oracles"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              Centralised Agreement
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Establish a unified platform for claims coordination and contract decision-making with enhanced capabilities.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="orange.600" mb={4}>
                  Key Capabilities
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="orange.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Unified claims coordination
                    </Text>
                  </Box>

                  <Box p={4} bg="orange.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Consolidated decision management
                    </Text>
                  </Box>

                  <Box p={4} bg="orange.50" borderRadius="md">
                    <Text color="gray.700" fontSize="md">
                      Advanced processing capabilities
                    </Text>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="orange.600" mb={4}>
                  Description
                </Heading>
                <Box p={4} bg="orange.50" borderRadius="md">
                  <Text color="gray.700" fontSize="md" lineHeight="1.8">
                    Oracles provides a unified platform for coordination and decisioning across your (re)insurance operations, enabling faster and more consistent outcomes through enhanced capabilities.
                  </Text>
                </Box>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="orange"
                size="lg"
                onClick={() => navigate("/oracles")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Explore Oracles
              </Button>
            </Box>
          </Box>

        </Stack>
      </Container>
    </Box>
  );
};

export default OraclesDescription;
